import dynamic from 'next/dynamic';

export const LayoutModal = dynamic(
  () => import('./LayoutModal').then((mod) => mod.LayoutModal),
  { ssr: false },
) as React.FC;
